module.exports = {"522325001":"永丰街道","522325002":"珉谷街道","522325101":"龙场镇","522325102":"者相镇","522325103":"北盘江镇","522325104":"白层镇","522325105":"鲁贡镇","522325106":"小屯镇","522325107":"长田镇","522325108":"沙坪镇","522325109":"挽澜镇","522325200":"连环乡","522325204":"平街乡","522325205":"鲁容乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522325.json
// module id = 2506
// module chunks = 0